<li>
    <button class="menu-button font-12"
            type="button"
            [ngClass]="{ 'bg-style-light': !isActive(), 'bg-style': isActive() }"
            (click)="buttonClick.emit()">
        <div class="menu-button-content">
            <div class="menu-button-label"
                 [ngClass]="{
                    'active-label': isActive(),
                    'module-label font-regular' : isModule(),
                    'font-bold': !isModule(),
                }">
                {{ subtitle() }}
            </div>
            @if (!isActive()) {
                <div class="plus-icon bg-style">+</div>
            }
        </div>
    </button>
</li>
